export default __webpack_public_path__ + "static/media/warehouse.6ad62859.svg";